import {
  requestDeleteSchool,
  requestGetSchool,
  requestPostCreateSchool,
  requestUpdateSchool,
} from 'app/api/school'
import {
  IParamsGetSchool,
  IPayloadCreateSchool,
  IPayloadUpdateSchool,
  IResponseSchoolList,
  ISchool,
} from 'app/api/school/model'
import { getToken } from 'app/service/storage/storage-service'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { IResponseQueryList } from '../model/common'
import { SchoolKeys } from '../query-key/school'

/* eslint-disable @typescript-eslint/no-explicit-any */
export function useGetSchoolList(params: IParamsGetSchool, enabled = true) {
  const token = getToken()
  return useQuery<IResponseQueryList<ISchool[]>, undefined>(
    SchoolKeys.listSchool(params),
    async () => {
      try {
        const res: IResponseSchoolList = await requestGetSchool(params)
        const data: ISchool[] = res?.data?.rows || []
        return {
          data,
          total: res?.data?.total ?? 0,
        }
      } catch (error: any) {
        return {
          data: [],
          total: 0,
        }
      }
    },
    {
      enabled: !!token && enabled,
    },
  )
}

export const useDeleteSchool = () => {
  const query = useQueryClient()
  return useMutation<unknown, unknown, number[], unknown>(
    async (body: number[]) => {
      await requestDeleteSchool(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: SchoolKeys.allSchools,
        })
      },
    },
  )
}

export const useUpdateSchool = () => {
  const query = useQueryClient()
  return useMutation<unknown, unknown, IPayloadUpdateSchool, unknown>(
    async (body: IPayloadUpdateSchool) => {
      return await requestUpdateSchool(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: SchoolKeys.allSchools,
        })
      },
    },
  )
}

export const useCreateSchool = () => {
  const query = useQueryClient()
  return useMutation<unknown, unknown, IPayloadCreateSchool, unknown>(
    async (body: IPayloadCreateSchool) => {
      return await requestPostCreateSchool(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: SchoolKeys.allSchools,
        })
      },
    },
  )
}
